import { render, staticRenderFns } from "./AboutCTAButton.vue?vue&type=template&id=7c287c65&scoped=true"
import script from "./AboutCTAButton.vue?vue&type=script&lang=js"
export * from "./AboutCTAButton.vue?vue&type=script&lang=js"
import style0 from "./AboutCTAButton.vue?vue&type=style&index=0&id=7c287c65&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c287c65",
  null
  
)

export default component.exports